export interface Shortcuts {
  viewTicketBoard: string;
  createTicket: string;
  openSearch: string;
}

export interface DefaultShortcuts {
  ARROWDOWN?: string;
  ARROWUP?: string;
  ESCAPE?: string;
}

export const CUSTOMIZABLE_SHORTCUTS: Shortcuts = {
  viewTicketBoard: 'Meta+B',
  createTicket: 'Meta+E',
  openSearch: 'Meta+D',

};

export const DEFAULT_SHORTCUTS: DefaultShortcuts = {
  ARROWDOWN: 'ArrowDown',
  ARROWUP: 'ArrowUp',
  ESCAPE: 'Escape',
};
